import React from 'react'
import { useConfigState, useUIFunctions } from '@sentecacommerce-theme/lib'

import { Copy, Modal } from '../../../Common'

export type GDPRModalProps = {
  html: string
}
export const GDPRModal = ({ html }: GDPRModalProps) => {
  const { closeViewById } = useUIFunctions()
  const config = useConfigState()
  return (
    <Modal
      open
      noTitlePadding
      fullOnMobile
      handleClose={() => closeViewById(config.views.gdprModal)}
    >
      <Copy html={html} />
    </Modal>
  )
}
